import { render, staticRenderFns } from "./arrange.vue?vue&type=template&id=4aa84869&scoped=true&"
import script from "./arrange.vue?vue&type=script&lang=js&"
export * from "./arrange.vue?vue&type=script&lang=js&"
import style0 from "./arrange.vue?vue&type=style&index=0&id=4aa84869&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aa84869",
  null
  
)

export default component.exports